var modal = document.querySelector('#modal');
var modalOverlay = document.querySelector('#modal-overlay');
var closeButton = document.querySelector('#close-button');
var openButton = document.querySelector('#open-button');

closeButton.addEventListener('click', function () {
  modal.classList.toggle('closed');
  modalOverlay.classList.toggle('closed');
});

openButton.addEventListener('click', function () {
  modal.classList.toggle('closed');
  modalOverlay.classList.toggle('closed');
});
